import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	itemGotoOpsgenie: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.goto-opsgenie.item-goto-opsgenie',
		defaultMessage: 'Opsgenie incidents',
		description: 'Navigation item text which redirects to the Opsgenie page',
	},
	itemGotoOpsgenieItemTooltip: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.goto-opsgenie.item-goto-opsgenie-item-tooltip',
		defaultMessage: 'View the incidents in your connected Opsgenie account.',
		description: 'Tooltip for the navigation item which redirects to the Opsgenie page',
	},
});
